<div bsModal #modal="bs-modal" class="modal fade pdf-form" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ queryParams.modalTitle | translate }}</h4>
            </div>
            <div class="modal-body">
                <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)">
                    <div class="row">
                        <div class="form-group col-xs-12">
                            <input formControlName="show" type="checkbox" id="show-on-support"/>
                            <label for="show-on-support">{{ 'Show PDF on Support page' | translate }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-4 pdf-form--thumbnails">
                            <div class="mr-t--md"></div>
                            <label for="title">{{ 'PDF thumbnails' | translate }}</label>
                            <div class="img-space">
                                <ng-container *ngIf="isImageSaved || thumbnail; else elseTemplate">
                                    <img class="pdf-thumbnails" width="100%" height="240" [src]="thumbnail"/>
                                </ng-container>
                                <ng-template #elseTemplate>
                                    <i class="fal fa-file-pdf pdf-icon"></i>
                                </ng-template>
                                <div class="img-space--button">
                                    <image-upload class="image-upload-extension"
                                                  [headers]="{'Authorization': 'Bearer ' + authService.user['token']}"
                                                  [max]="10" [maxFileSize]="2000000"
                                                  [fileTooLargeMessage]="('Image too large!' | translate)"
                                                  [extensions]="['jpg','jpeg','png']"
                                                  [url]="authService.baseUrl + pdfsService.url + '/upload-picture/' + language"
                                                  [buttonCaption]="('Select a picture to upload' | translate)"
                                                  (uploadFinished)="thumbnailUploaded($event)"
                                                  (uploadStateChanged)="thumbnailUploading($event)"
                                                  [preview]="false" dropBoxMessage="">
                                    </image-upload>
                                    <small class="">{{ 'Max file size: 2MB. Recommend format: jpg, jpeg and png' |
                                        translate }}
                                    </small>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-12 fileInputProfileWrap mr-t--sm">
                                    <label for="title">{{ 'PDF Upload' | translate }}</label>
                                    <div>
                                        <input matInput id="imageUpload" type="file" (change)="fileChangeEvent($event)" class="fileInputProfile hidden" />
                                        <label for="imageUpload" class="btn btn-primary btn-upload">{{ 'Upload file' | translate }}</label>
                                        <div *ngIf="pdf.pdf && pdf.pdf_url" class="mr-t--sm">
                                            <span>{{ 'PDF' | translate }} : 
                                                <a href="{{ pdf.pdf_url }}" target="_blank" rel="noopener"> {{ pdf.pdf }}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="imageError" class="row" role="alert">
                                <div class="col-sm-12">
                                    <div class="alert alert-danger">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                        {{ imageError | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-8 pdf-form--content">

                            <input type="hidden" formControlName="id">
                            <div *ngIf="successMessage" class="row form-group" role="alert">
                                <div class="col-sm-12">
                                    <div class="alert alert-info">
                                        {{ successMessage | translate }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                                <div class="col-sm-10">
                                    <div class="alert alert-danger">
                                        <div *ngFor="let error of errorMessage">
                                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                            {{ error | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <span *ngIf="pdf && pdf['language_flag']">
                                        <img [src]="pdf['language_flag']">
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <label for="title">{{ 'PDF name' | translate }} *</label>
                                    <input type="text" class="form-control" id="title" formControlName="title">
                                    <small class="form-text text-danger" [hidden]="form.controls.title.valid ||
                                                                           (form.controls.title.pristine &&
                                                                           !formSubmitted)">
                                        {{ 'PDF Name is required.' | translate }}
                                    </small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <label for="title">{{ 'PDF Description' | translate }}</label>
                                    <app-tinymce #pdfDescription formControlName="description"
                                                 id="content"
                                                 [options]="
                                                            {
                                                            menubar: false,
                                                            toolbar: 'bold italic alignleft numlist bullist link formatselect | removeformat'
                                                            }"
                                    ></app-tinymce>
                                    <br>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                        {{ 'Cancel' | translate }}
                                    </button>
                                    <button type="submit" class="btn btn-primary">
                                        <span>{{ 'Save' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
